import {SidebarAlign} from '@modules'
import {CatalogStore, globalStores, LibraryItemConfig} from '@stores'
import {CatalogInstanceChildStore} from '@stores/catalog/CatalogInstanceChildStore'
import {action, computed, observable} from 'mobx'

export const isTagLibrary = ({index}: { index?: string }) => {
  return index === globalStores.es.indexes.tag
}

export type LibraryItemConfigWrapper = LibraryItemConfigWrapperStore & LibraryItemConfig;

export class LibraryItemConfigWrapperStore extends CatalogInstanceChildStore {
  constructor(catalog: CatalogStore, l : LibraryItemConfig) {
    super(catalog)
    this.config = l
    Object.assign(this, _.omit(l, ['id', 'count', 'dataMap', 'label', 'isTagLibrary', 'catalogField', 'workspace', 'title', 'config']))
  }

  @computed get count() {
    //count: aggregations
    //                ? v.index || v.where
    //                  ? aggregations[v.name || v.attrName]?.count?.value
    //                  : null
    //                : null

    return (this.stores.sidebar.left.catalogLibraries?.countById ?? {})[this.id]?.doc_count
  }

  @computed get filterStore() {
    return this.catalog.filter.storeByLibraryId.get(this.id)
  }

  @observable config : LibraryItemConfig

  @computed get label() {
    return this.catalog.labelForLibrary({id: this.id}, 'singular', false)
  }

  @computed get labelWithWorkspace() {
    return this.catalog.labelForLibrary({id: this.id}, 'singular', true)
  }

  @computed get id() {
    return LibraryItemConfigWrapperStore.idFor(this.catalog, this.config)
  }

  @computed get title() {
    const {config: {name}, label} = this
    return _.capitalize(label ?? name)
  }

  @computed get workspace() {
    return this.catalog.workspaceByIndex[this.config.index]
  }

  @computed get dataMap() {
    return this.catalog.dataMapForLibrary(this.config)
  }

  @computed get catalogField() {
    const {catalog, config: {assignTo, assignTo2, catalogFields}} = this
    return catalog._fieldByName[assignTo ?? assignTo2?.field ?? _.first(catalogFields)]
  }

  @computed get catalogItemByAssignTo() : { [id: string]: Array<any> } {
    const {catalog, config: {assignTo}} = this
    if (!assignTo) { return {}}

    return _.groupBy(catalog.catalogItems, ci => _.get(ci, `${assignTo}.id`))
  }

  @computed get isTagLibrary() {
    return isTagLibrary(this.config)
  }

  static idFor(catalog: CatalogStore, config: LibraryItemConfig) {
    if (!catalog?.workspaceByIndex) debugger
    const {index, name} = config,
      workspace = catalog.workspaceByIndex[index]
    return `${workspace && workspace?._id != catalog?.id ? `${workspace?._id}|` : ''}${index}|${name}`
  }

  @action navigateTo = (align: SidebarAlign = 'left') => {
    this.stores.sidebar[align].navigateToLibrary({libraryId: this.id}, true)
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/LibraryItemConfigWrapper.ts